var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135)",
    fill: "#2ca9b7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.5 31.4l-13 13c2.8 4.6 4.4 9.9 4.4 15.7 0 16.6-13.4 30-30 30-5.7 0-11.1-1.6-15.7-4.4l-13 13c8 5.9 17.9 9.5 28.6 9.5 26.5 0 48-21.5 48-48 .2-10.9-3.3-20.8-9.3-28.8zM165 60c0-16.6 13.4-30 30-30 5.7 0 11.1 1.6 15.7 4.4l13-13c-8-5.9-17.9-9.5-28.6-9.5-26.5 0-48 21.5-48 48 0 10.7 3.5 20.6 9.5 28.6l13-13c-3-4.4-4.6-9.8-4.6-15.5z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 108,
    r: 12
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconex);
export default __webpack_public_path__ + "static/media/iconex.4baef6c6.svg";
export { ForwardRef as ReactComponent };